import React, { useState, useEffect, useMemo } from 'react'
import { connect } from "react-redux"
import TopBarNav from '../common/TopBarNav'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { useHistory } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import * as telematicsActions from '../../actions/telematics/TelematicsActions'
import { downloadCSV, getTableColumnsByStage } from "../common/Utils"
import { TelematicsStyles } from './TelematicsStyles'
import TableFilterComponentCollateralTelematics from '../common/TableFilterComponentCollateralTelematics'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Modal from 'antd/es/modal';
import { customStylePrincipal } from '../common/CommonStyles'

const TelematicsListByStatus = ({ classes, ...props }) => {
    const history = useHistory()
    const [filterText, setFilterText] = useState('')
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const { match: { params } } = props
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t, i18n } = useTranslation()
    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const excelConfiguration = [
        {
            selector: 'installationOrderId',
            label: t('common.installationOrderId')
        },
        {
            selector: 'statusDesc',
            label: t('common.status')
        },
        {
            selector: 'installers',
            label: t('common.installers'),
            propToJoin: 'name'
        },
        {
            selector: 'installationOrderDate',
            label: t('common.installationOrderDate'),
        },
        {
            selector: 'createDate',
            label: t('common.creationDate'),
        }
    ]

    useEffect(() => {
        const newRoute = {
            path: '/telematics/listByStatus',
            linkLegend: t(`telematicsDashboard.${params.status}`),
            urlParams: [{ key: 'status', value: params.status }, { key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)
        if (filterText.length === 0 || filterText.length >= 5) {
            handleOpenBackdrop()
            props.actions.fecth_filter_by_date(props.userLanguage, props.userToken, "", "", params.status, params.branchOfficeId, filterText, onError, onSuccess)
            props.cleanUserProfile()
        }
    }, [filterText]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            setFilterText('')
            setStartDate(null)
            setEndDate(null)
        }

        const handleStartDateChange = (e) => {
            if (e != null)
                setStartDate(e.format('YYYY-MM-DD'))
            else
                setStartDate(null)
        }

        const handleEndDateChange = (e) => {
            if (e != null)
                setEndDate(e.format('YYYY-MM-DD'))
            else
                setEndDate(null)
        }

        const handleDateSearch = () => {
            handleOpenBackdrop()
            props.actions.fecth_filter_by_date(props.userLanguage, props.userToken, startDate, endDate, params.status, params.branchOfficeId, "", onError, onSuccess)
        }

        const handlerSearchByText = () => {
            handleOpenBackdrop()
            props.actions.fecth_filter_by_date(props.userLanguage, props.userToken, "", "", params.status, params.branchOfficeId, filterText, onError, onSuccess)
            props.cleanUserProfile()
        }

        return <TableFilterComponentCollateralTelematics
            onFilter={e => setFilterText(e.target.value)}
            onClear={handleClear} filterText={filterText}
            onclickSearchByText={handlerSearchByText}
            onStartDateChange={handleStartDateChange}
            onEndDateChange={handleEndDateChange}
            onClickSearch={handleDateSearch}
            onExport={() => downloadCSV(props.listByStatus, excelConfiguration)}
            styles={classes.searchAlign}
        />;
    }, [filterText, props]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}></Grid>
                </Grid>
                <Grid>
                    <DataTable
                        title={t(`telematicsDashboard.${params.status}`)}
                        columns={getTableColumnsByStage(("Telematics"), params.status, i18n.language)}
                        data={props.listByStatus}
                        defaultSortField="installationOrderId"
                        customStyles={customStylePrincipal}
                        highlightOnHover
                        dense
                        responsive
                        striped
                        pointerOnHover
                        pagination
                        paginationComponentOptions={paginationOptions}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                    />
                </Grid>
                <br />
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    listByStatus: state.TelematicsReducer.listOrders,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language,
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(telematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(TelematicsListByStatus))